webpackJsonp([142629428675168],{

/***/ 751:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-444cf217d3ecd7d9367a.js